<template>
  <div class="lv-list-box">
    <Header pageTitle="学术论文" />
    <ListDropdown
      :dropdownValue="dropdownValue"
      :dropdownOption="dropdownoption"
      :total="total"
      @getDropdownValue="getDropdownValue"
    />
    <div class="tab-box">
      <span
        :class="['tab-item', params.channelId1 === 3 ? 'tab-item-active' : '']"
        @click="tabChange(3)"
        >学术精汇</span
      >
      <span
        :class="['tab-item', params.channelId1 === 4 ? 'tab-item-active' : '']"
        @click="tabChange(4)"
        >百科精选</span
      >
      <span
        :class="['tab-item', params.channelId1 === 5 ? 'tab-item-active' : '']"
        @click="tabChange(5)"
        >学术综述</span
      >
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="lv-list" v-if="loading || articleList.length > 0">
        <LvItem
          class="lv-list-item"
          v-for="item in articleList"
          :key="item.articleId"
          :title="item.title"
          :artSummary="item.artSummary"
          :author="item.firstAuthor"
          :otherAuthor="item.authors.length > 1 ? ',...' : ''"
          :periodicalName="item.periodical"
          :periodicalTime="`${item.journalsYear}年第${item.journalsTerm}期`"
          @click.native="toDetail(item.articleId)"
        />
      </div>
      <noneList noneType="lvList" v-else />
    </van-list>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
import ListDropdown from "@/views/mobileView/components/header/listDropdown";
import LvItem from "@/views/mobileView/components/listItem/lvItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "AcademicPaper",
  components: {
    Header,
    ListDropdown,
    LvItem,
    noneList,
  },
  data() {
    return {
      dropdownValue: "0",
      dropdownoption: [{ text: "全部", value: "0" }],
      params: {
        pageNo: 0,
        pageSize: 20,
        channelId1: 3,
        classifyNumber: "",
        beginDateTime: "",
        projectId: 1,
      },
      total: 0,
      articleList: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  created() {
    this.getDropdownOption();
  },
  methods: {
    // 获取筛选列表
    async getDropdownOption() {
      const res = await this.$apis.mainServe.classificationOneList();
      let optionsArr = res.classOneList.map((item) => {
        return {
          text: item.classifyName,
          value: item.classifyNumber,
        };
      });
      this.dropdownoption.push(...optionsArr);
    },
    // 获取选中列表筛选项
    getDropdownValue(value) {
      if (value === "0") {
        this.params.classifyNumber = "";
      } else {
        this.params.classifyNumber = value;
      }
      this.dropdownValue = value;
      this.params.pageNo = 1;
      this.articleList = [];
      this.getList();
    },
    // 论文tab栏切换
    tabChange(tabValue) {
      this.params.channelId1 = tabValue;
      this.getDropdownValue("0");
    },
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      if (this.params.pageNo == 1) {
        this.params.beginDateTime = this.$global.transferDate(new Date());
      }
      const resp = await this.$apis.mainServe.getListByChannel(this.params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 20;
        this.articleList.push(...resp.data.list);
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id) {
      this.$router.push({
        name: "thesisDetail",
        query: {
          id: id,
          type: 0,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.lv-list-box {
  padding-top: 44px;
  padding-bottom: 12px;
  min-height: 100vh;
  background-color: #f5f5f5;
  .tab-box {
    margin: 12px 12px;
    .tab-item {
      margin-right: 12px;
      display: inline-block;
      padding: 0 13px;
      height: 30px;
      line-height: 30px;
      background-color: #fff;
      border-radius: 15px;
      font-size: 15px;
      color: #333333;
    }
    .tab-item-active {
      background-color: #4a79f1;
      color: #fff;
    }
  }
  .lv-list {
    margin: 12px auto 0;
    width: 351px;
    padding: 0 13px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .lv-list-item {
      border-bottom: 1px solid #eee;
      &:last-child {
        border: none;
      }
    }
  }
}
</style>
